import * as types from "./types";
import { Commit } from "vuex";
import {
	autoRenewalOptionAxios,
	paidOptionsAxios,
	payActivatedChannelsAxios,
	payBalanceAxios,
	payChannelAxios,
	payChannelDetailAxios,
	payFailAxios,
	payGetBalanceAxios,
	payHistoryAxios,
	payOptionsAxios,
	payOptionsRenewalAxios,
	payOptionsSuccessAxios,
	paySuccessAxios,
} from "@/store/payment/services";

/**
 * Информация для формы - Оплата (каналы)
 * @param commit
 * @param payload
 */
export async function payChannelDetailAction({
	commit,
}: {
	commit: Commit;
}): Promise<void> {
	try {
		const { data } = await payChannelDetailAxios();
		commit(types.PAY_CHANNEL_DETAIL, data.result);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Покупка каналов
 * @param commit
 * @param payload
 */
export async function payChannelAction(
	{ commit }: { commit: Commit },
	payload: {
		amount: number;
		type: number;
	}
): Promise<void> {
	try {
		const { data } = await payChannelAxios(payload);

		commit(types.PAY_CHANNEL, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Пополнение баланса
 * @param commit
 * @param payload
 */
export async function payBalanceAction(
	{ commit }: { commit: Commit },
	payload: {
		amount: number;
	}
): Promise<void> {
	try {
		const { data } = await payBalanceAxios(payload);

		commit(types.PAY_BALANCE, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Успешное пополнение
 * @param commit
 * @param payload
 */
export async function paySuccessAction(
	{ commit }: { commit: Commit },
	payload: {
		id: number;
	}
): Promise<void> {
	try {
		const { data } = await paySuccessAxios(payload);

		commit(types.PAY_SUCCESS, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Оплата не прошла
 * @param commit
 * @param payload
 */
export async function payFailAction(
	{ commit }: { commit: Commit },
	payload: {
		id: number;
		payType: number;
	}
): Promise<void> {
	try {
		const { data } = await payFailAxios(payload);

		commit(types.PAY_FAIL, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Количество активированных каналов
 * @param commit
 */
export async function payActivatedChannelsAction({
	commit,
}: {
	commit: Commit;
}): Promise<void> {
	try {
		const { data } = await payActivatedChannelsAxios();

		commit(types.PAY_ACTIVATED_CHANNELS, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Количество активированных каналов
 * @param commit
 */
export async function payGetBalanceAction({
	commit,
}: {
	commit: Commit;
}): Promise<void> {
	try {
		const { data } = await payGetBalanceAxios();

		commit(types.PAY_GET_BALANCE, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * История покупок
 * @param commit
 */
export async function payHistoryAction({
	commit,
}: {
	commit: Commit;
}): Promise<void> {
	try {
		const { data } = await payHistoryAxios();

		commit(types.PAY_HISTORY, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Покупка опций
 * @param commit
 * @param payload
 */
export async function payOptionsAction(
	{ commit }: { commit: Commit },
	payload: {
		optionsIds: Array<number>;
		instanceId: number;
		isPayMonth: boolean;
	}
): Promise<void> {
	try {
		const { data } = await payOptionsAxios(payload);

		commit(types.PAY_OPTIONS, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Покупка опций прошла успешно
 * @param commit
 * @param payload
 */
export async function payOptionsSuccessAction(
	{ commit }: { commit: Commit },
	payload: {
		id: number;
		instanceId: number;
		newExpired: number;
	}
): Promise<void> {
	try {
		const { data } = await payOptionsSuccessAxios(payload);

		commit(types.PAY_OPTIONS_SUCCESS, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Получаем список купленных опций для инстанса
 * @param commit
 * @param payload
 */
export async function paidOptionsAction(
	{ commit }: { commit: Commit },
	payload: { instanceId: number }
): Promise<void> {
	try {
		const { data } = await paidOptionsAxios(payload);

		commit(types.PAY_OPTIONS_LNK_INSTANCE, data.data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Автопродление опции (для checkbox)
 * @param commit
 * @param payload
 */
export async function autoRenewalOptionAction(
	{ commit }: { commit: Commit },
	payload: {
		instanceId: number;
		optionId: number;
		isActive: number;
	}
): Promise<void> {
	try {
		const { data } = await autoRenewalOptionAxios(payload);

		commit(types.AUTO_RENEWAL_OPTION, data.data);
	} catch (e) {
		console.log(e);
	}
}

// Продление опций
export async function payOptionsRenewalAction(
	{ commit }: { commit: Commit },
	payload: {
		id: number;
		instanceId: number;
		newExpired: number;
	}
): Promise<void> {
	try {
		const { data } = await payOptionsRenewalAxios(payload);

		commit(types.PAY_OPTIONS_RENEWAL, data.data);
	} catch (e) {
		console.log(e);
	}
}
